export enum CreditNotePurposeEnum {
  FIX_OVERPAYMENT = 'fix_overpayment',
  INVOICE_CORRECTION = 'invoice_correction',
  GOODS_RETURN = 'goods_return',
  OIN_CORRECTION = 'oin_correction',
  IIN_CORRECTION = 'iin_correction',
  COMMON_CORRECTION = 'common_correction',
  ERA_CORRECTION = 'era_correction',
  COMMISSION = 'commission',
}
